import { Component, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateDirective } from '@ngx-translate/core';

import { ToggleComponent } from '../../../../components/toggle/toggle.component';

@Component({
  selector: 'td-wb-holdings-drip-reinvest-toggle',
  templateUrl: 'holdings-drip-reinvest-toggle.component.html',
  imports: [
    FormsModule,
    ToggleComponent,
    TranslateDirective
  ]
})
export class HoldingsDripReinvestToggleComponent {
  readonly selection: InputSignal<boolean> = input.required<boolean>();
  readonly toggleId: InputSignal<string> = input.required<string>();
  readonly disabled: InputSignal<boolean> = input<boolean>(false);
  readonly selectionChange: OutputEmitterRef<boolean> = output<boolean>();

  onToggleChange(value: boolean): void {
    this.selectionChange.emit(value);
  }
}
